/**
 * Public, no-login PAPER (`/d/:token`) — the target of the QR printed on every
 * customer-facing document and of the WhatsApp `{link}` placeholder.
 *
 * Deliberately twelve lines: the whole point is that the customer sees the SAME
 * DocumentPrintPage the staff do, fed by one anonymous read instead of four
 * authed ones. Anything rendered here instead would be a second layout to keep
 * in sync.
 */
import { useParams } from 'react-router-dom';

import { DocumentPrintPage } from '../documents/DocumentPrintPage.js';

export function PublicDocumentPage(): JSX.Element {
  const { token } = useParams<{ token: string }>();
  // An empty token still renders: the API rejects it and the page shows the
  // same "invalid or expired" copy a tampered one gets.
  return <DocumentPrintPage publicToken={token ?? ''} />;
}
